import CreateSpokenDialogueView from "@features/tools/view/spoken-dialogue-view/create-spoken-dialogue-view";

const CreateSpokenDialogue = () => {
  return <CreateSpokenDialogueView />;
};

export default CreateSpokenDialogue;
